import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import { TableWrapper, Badge, Filters, SliderOverlay, ConfirmModal, ToggleCheckbox } from "../../component/common/"
// import { CityModal } from "../../component/master"
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { getCityListDetails, deleteCity, changeCityStatus } from "../../redux/actions/master"
import { getSNo } from "../../services/helperFunctions"
import { LoaderWrapper } from "../../HOC"

import NoImage from '../../assets/images/noimage.png';

class cityClass extends Component {

	state = {
		headerDetails: [
			{
				label: 'S.No'
			},
			{
				label: 'Series No',
			},
			// {
			// 	label: 'Image',
			// },
			{
				label: 'City',
			},
			{
				label: 'Location'
			},
			{
				label: 'Status',
			},
			{
				label: "Change Status"
			},
			{
				label: 'Action'
			},

		],
		filter: [


			{
				label: 'Active',
				value: 1
			},
			{
				label: 'Deactive',
				value: 2
			}

		],
		cityLists: {

		},
		selectedFilter: 'Active',
		cityDetails: {
			cityName: '',
			seriesNo: '',
			city_image: ''

		},
		cityStatusChange: {
			cityId: "",
			status: ""
		},
		isError: false,
		isOpen: false,
		isEdit: false,
		ConfirmModalOpenStatus: false,
		ConfirmModalChangeActiveStatus: false,
		id: ''
	}


	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}



	requestStatus = (status) => {

		if (status === 1) {
			return <Badge
				type={1}
				label={"Active"}
			/>
		} else if (status === 0) {
			return <Badge
				type={2}
				label={"Inactive"}
			/>
		}

	}

	handleFilter = (query, value, name) => {

		if (name == "filter") {

			this.setState({
				selectedFilter: query
			})
			query = {
				page: 1,
				filter: query
			}
		}

		console.log(11111111111111, query)


		this.props.getCityListDetails(query)


	}


	handleAdd = (id) => {
		// let cityDetails = {
		// 	city_name: '',
		// 	series_no: '',
		// 	location: '',
		// 	city_image: '',
		// 	latitude: '',
		// 	longitude: '',
		// 	description: '',
		// }
		// this.setState({
		// 	isOpen: true,
		// 	cityDetails
		// })

		if (id) {

			this.props.history.push(`/dashboard/editcity/${id}`)

		} else {

			this.props.history.push('/dashboard/addcity')

		}



	}



	handleEdit = (index) => {

		let { cityLists: { list }, } = this.props

		let cityDetails = list[index]

		this.setState({
			isEdit: true,
			cityDetails,
			currentIndex: index,

		})

		this.toggle("isOpen")

	}

	toggle = item => {
		this.setState(prevState => ({
			[item]: !prevState[item]
		}));
	}

	toggleStatusChange = (id, stat) => {
		let cityStatusChange = {}
		cityStatusChange.cityId = id;
		cityStatusChange.status = stat
		this.setState({
			cityStatusChange
		})
		this.toggle('ConfirmModalChangeActiveStatus')
	}

	changeStatus = () => {
		const { cityStatusChange: { cityId, status } } = this.state
		const body = {
			cityId: cityId,
			status: status === 0 ? 1 : 0
		}
		this.props.changeCityStatus(body).then(() => {
			this.props.getCityListDetails()
			this.toggle('ConfirmModalChangeActiveStatus')
		})
	}

	handleModal = () => {

		let temp = {
			city_name: '',
			series_no: '',
			location: '',
			city_image: '',
			latitude: '',
			longitude: '',
			description: '',
		}

		this.setState({
			isError: false,
			isOpen: false,
			isEdit: false,
			categoryDetails: temp

		})
	}

	handleDeleteToggle = (id) => {

		this.setState({
			id
		})

		this.toggleDelete("ConfirmModalOpenStatus")

	}


	handleDelete = () => {
		let { id } = this.state

		this.props.deleteCity(id).then(() => {

			this.props.getCityListDetails()

			this.toggleDelete("ConfirmModalOpenStatus")

		})

	}

	toggleDelete = (name) => {
		this.setState({
			[name]: !this.state[name]
		})
	}

	render() {

		let { headerDetails, filter, selectedFilter, cityDetails, isError, isOpen, isEdit, ConfirmModalOpenStatus, ConfirmModalChangeActiveStatus } = this.state
		let { cityLists } = this.props
		let IsEmpty = cityLists.list.length > 0

		return (
			<div>
				<div className="sair-pg-header">
					<h4 className="sair-pg-title align-self-center">
						<span className="pg-title-icon">
							<span className="feather-icon">
								<svg
									xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" className="feather feather-align-left">
									<line x1="17" y1="10" x2="3" y2="10"></line>
									<line x1="21" y1="6" x2="3" y2="6"></line>
									<line x1="21" y1="14" x2="3" y2="14"></line>
									<line x1="17" y1="18" x2="3" y2="18"></line>
								</svg>
							</span>
						</span>City
					</h4>
					<div className="col-auto ">
						<button className="btn btn-primary btn-sm"
							onClick={() => this.handleAdd()}
						>Add City</button>
					</div>
				</div>
				<section className="sair-sec-wrapper">
					<div className="row">
						<div className="col-sm">
							<div className="row no-gutters">
								<h5 className="sair-sec-title align-self-center">City List</h5>
								<div className="ml-auto d-flex align-items-center">
									{/* <UncontrolledDropdown setActiveFromChild className="filter-dropdown">
										<DropdownToggle tag="a" className="custom-caret dropdown-toggle-link">
											Filter by: {selectedFilter}
										</DropdownToggle>
										<DropdownMenu>
											{filter.map(({ label, value }, index) => {
												return (
													<DropdownItem
														onClick={e => this.handleFilter(label, value, "filter")}
														key={index}
													>
														{label}
													</DropdownItem>

												)
											})}
										</DropdownMenu>
									</UncontrolledDropdown> */}

									<div className="search-box position-relative  ml-3">

										<Filters
											queryHandler={(query) => this.handleFilter(query)}
											isDropDownFilter={false}
										/>
									</div>
								</div>
							</div>
							<div className="table-wrap mt-3">
								<TableWrapper
									headerDetails={headerDetails}
									isEmpty={IsEmpty}
									pageMeta={cityLists.pageMeta}
									queryHandler={(query) => this.handleFilter(query)}


								>
									{cityLists.list.map((item, index) => {
										let { id, series_no, city_name, location, status, city_imageUrl } = item

										return (
											<tr
												key={index}  >
												<td>{getSNo(cityLists.pageMeta, index)}</td>
												<td>{series_no}</td>
												{/* <td><img className="list-img" src={city_imageUrl ? city_imageUrl : NoImage} /></td> */}
												<td>{city_name}</td>
												<td>{location}</td>
												<td>{this.requestStatus(status)}</td>
												<td><ToggleCheckbox value={status} onClick={() => this.toggleStatusChange(id, status)} /></td>
												<td>
													<a className="mr-25"
														onClick={e => this.handleAdd(id)}
													>
														<i className="icon-pencil  text-primary cursor-pointer"
														></i>
													</a>
													<a ><i
														className="icon-trash txt-danger text-primary cursor-pointer"
														onClick={e => this.handleDeleteToggle(id)}
													></i>
													</a>
												</td>

											</tr>

										)

									})}


								</TableWrapper>
							</div>
						</div>
					</div>
				</section>



				{/* <SliderOverlay isOpen={isOpen} toggle={this.handleModal} size='30%'>
					<div className="side-slider h-100 position-relative">
						<div className="h-100 flex-with-center"> */}

				{/* <CityModal
					isError={isError}
					toggle={this.handleModal}
					isEdit={isEdit}
					modalDetails={cityDetails}
				/> */}

				{/* </div>

					</div>
				</SliderOverlay> */}

				<ConfirmModal
					isOpen={ConfirmModalChangeActiveStatus}
					keyName="ConfirmModalChangeActiveStatus"
					toggle={() => {
						let { cityStatusChange } = this.state
						cityStatusChange.cityId = null;
						cityStatusChange.status = null;
						this.setState({
							cityStatusChange
						}, () => this.toggle('ConfirmModalChangeActiveStatus'))
					}}
					handleSubmit={() => this.changeStatus()}
				>
					<h5>Are you sure you want to change the Activity's status?</h5>
				</ConfirmModal>

				<ConfirmModal
					keyName="ConfirmModalOpenStatus"
					toggle={this.toggle}
					isOpen={ConfirmModalOpenStatus}
					handleSubmit={() => this.handleDelete()}
					submitText='Delete'
				>
					<h5>
						Are you sure want to delete City?
					</h5>
				</ConfirmModal>

			</div>
		)
	}
}

const mapStateToProps = state => {

	return {
		cityLists: state.master.cityLists
	}


};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		getCityListDetails,
		changeCityStatus,
		deleteCity
	}, dispatch)
};


let actions = ['getCityListDetails']

let component = LoaderWrapper(cityClass)({ actions })

export const City = connect(mapStateToProps, mapDispatchToProps)(component)

